import { Button, Row } from 'antd'
import { Logo } from '../../components/Logo/Logo'

import { FadeIn } from '../../components/FadeIn'
import { useNavigate } from 'react-router-dom'

export const LandingPage = () => {
  const navigate = useNavigate()

  return (
    <FadeIn>
      <Row
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Logo />
        <h4 style={{ color: 'gray', fontStyle: 'italic' }}>
          Manage your campaigns and characters from the WoD
        </h4>
        <Button
          size={'large'}
          style={{ width: 180, marginTop: 24 }}
          onClick={() => navigate('/login')}
        >
          Login
        </Button>
      </Row>
    </FadeIn>
  )
}
